import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { Wrapper } from 'src/app/components/wrapper.component';
import { permissionsStateSelector } from 'src/app/store/permissions.era';
 
@Injectable({ providedIn: 'root'})
export class EventPrivateGuard  extends Wrapper<EventPrivateGuard> { // 
  $complete: Subject<boolean> = new Subject();

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    console.log("CAN ACTIVATE CALLED")
    return new Observable<boolean>((observer) => {
      const page = next.data.page_name
      this.subCallback(this.store.select(permissionsStateSelector), permissions => {
        if (!permissions.loaded) return
        this.$complete.next(true)
        observer.next(true)//  permissions.all.includes(page))
        observer.complete()
      }, this.$complete)
    })    
  }
}
